<template>
  <div class="crm-dashboard">
    <el-card class="data-simple" shadow="never">
      <div slot="header">
        <span>营销概况</span>
      </div>
      <el-tabs v-model="activeNameGeneralInfo" @tab-click="handleClickGeneralInfo">
        <!-- 用户数据权限范围（10：所有数据权限；20：仅本人数据权限 30：有部门数据权限） -->
        <el-tab-pane label="员工" name="1"></el-tab-pane>
        <el-tab-pane label="部门" name="2" v-if="userDataScope === '10' || userDataScope === '30'"></el-tab-pane>
        <el-tab-pane label="公司" name="3" v-if="userDataScope === '10'"></el-tab-pane>
      </el-tabs>
      <el-card shadow="never">
        <P>本月</P>
        <el-row :gutter="20">
          <el-col :xs="24" :md="12" :lg="8">
            <div >
              <el-card class="data-card" shadow="always">
                <div class="data-block">
                  <div class="value">{{generalInfo.monthNewAddClueCount}}</div>
                  <div class="label">新增潜在线索</div>
                </div>
              </el-card>
            </div>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8">
            <div>
              <el-card class="data-card" shadow="always">
                <div class="data-block">
                  <div class="value">{{generalInfo.monthNewAddContactCount}}</div>
                  <div class="label">新增潜在联系人</div>
                </div>
              </el-card>
            </div>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8">
            <div>
              <el-card class="data-card" shadow="always">
                <div class="data-block">
                  <div class="value">{{generalInfo.monthNewAddCrmContactCount}}</div>
                  <div class="label">新增CRM联系人</div>
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
        <P>累计</P>
        <el-row :gutter="10">
          <el-col :xs="24" :md="12" :lg="8">
            <div>
              <el-card class="data-card" shadow="always">
                <div class="data-block">
                  <div class="value">{{generalInfo.totalClueCount}}</div>
                  <div class="label">累计潜在线索</div>
                </div>
              </el-card>
            </div>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8">
            <div>
              <el-card class="data-card" shadow="always">
                <div class="data-block">
                  <div class="value">{{generalInfo.totalContactCount}}</div>
                  <div class="label">累计潜在联系人</div>
                </div>
              </el-card>
            </div>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8">
            <div>
              <el-card class="data-card" shadow="always">
                <div class="data-block">
                  <div class="value">{{generalInfo.totalCrmContactCount}}</div>
                  <div class="label">累计CRM联系人</div>
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </el-card>
    <el-card class="data-simple" shadow="never">
      <div slot="header">
        <span>营销统计</span>
      </div>
      <el-card shadow="never">
        <el-row>
          <el-col :xs="24" :md="12" :lg="6">
            <el-date-picker v-model="statisticsParam.dateRange" value-format="yyyy-MM-dd" type="daterange"
                            range-separator="-" style="width:100%" start-placeholder="开始日期"
                            end-placeholder="结束日期"></el-date-picker>
          </el-col>
          <el-col :xs="24" :md="12" :lg="6" :offset="1">
            <el-button type="primary" @click="queryStatisticsData">筛选</el-button>
          </el-col>
        </el-row>
        <P>官网指标</P>
        <el-row :gutter="20">
          <el-col :xs="24" :md="12" :lg="8"  v-for="item in statisticsInfo.officialWebsiteDataList">
            <div>
              <el-card class="data-card" shadow="always">
                <div class="data-block">
                  <div class="value">{{item.normValue}}</div>
                  <div class="label">{{item.normName}}</div>
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
        <P>名片指标</P>
        <el-row :gutter="20">
          <el-col :xs="24" :md="12" :lg="8"  v-for="item in statisticsInfo.businessCardDataList">
            <div >
              <el-card class="data-card" shadow="always">
                <div class="data-block">
                  <div class="value">{{item.normValue}}</div>
                  <div class="label">{{item.normName}}</div>
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
        <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top: 30px">
          <el-tab-pane label="文章" name="文章">
          </el-tab-pane>
          <el-tab-pane label="案例" name="案例">
          </el-tab-pane>
          <el-tab-pane label="产品" name="产品">
          </el-tab-pane>
        </el-tabs>
        <el-table v-loading="contentTableLoading" :data="dataList">
          <el-table-column label="名称" min-width="150" align="center" prop="name" />
          <el-table-column label="访问量" min-width="100" align="center" prop="readCount" />
          <el-table-column label="喜欢量" min-width="100" align="center" prop="likeCount" />
          <el-table-column label="被转发" min-width="100" align="center" prop="shareCount" />
        </el-table>
      </el-card>
    </el-card>
  </div>
</template>

<script>
import { marketingStatistics, contentStatistics, marketingGeneralInfo } from "@/api/saas/package";

import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapState } from "vuex";

export default {
  name: "index",
  props: {},
  data() {
    return {
      dataList: [],
      activeNameGeneralInfo: '1', // 营销概况tab
      generalInfo: {}, // 营销概况
      statisticsInfo: {}, // 营销统计
      activeName: '文章',
      statisticsParam: {
        dateRange: []
      },
      contentTableLoading: false
    };
  },
  computed: {
    ...mapState({
      userDataScope: state => state.user.userDataScope
    })
  },
  created() {
    // 默认本月1号到当天
    let today = new Date();
    let month = today.getMonth() < 9 ? "0" + (today.getMonth() + 1) : today.getMonth() + 1
    let day = today.getDate() < 10 ? "0" + today.getDate() : today.getDate()
    let todayStr = today.getFullYear() + "-" + month + "-" + day
    this.statisticsParam.dateRange.push(today.getFullYear() + "-" + month + "-01")
    this.statisticsParam.dateRange.push(todayStr)

    this.marketingGeneralInfo() // 营销概况
    this.queryStatisticsData()
  },
  methods: {
    // 营销概况
    marketingGeneralInfo() {
      marketingGeneralInfo({
        queryType: this.activeNameGeneralInfo
      }).then(response => {
        this.generalInfo = response.data;
      });
    },
    // 营销概况点击tab
    handleClickGeneralInfo(e) {
      this.marketingGeneralInfo()
    },
    handleClick(e) {
      this.statisticsInfo.contentHeatStatisticsDataList.find(item => {
        if (this.activeName === item.tabName) {
          this.dataList = item.list
          return true;
        }
      })
    },
    queryStatisticsData () {
      let param = {}
      if (this.statisticsParam.dateRange) {
        param = {
          startDateStr: this.statisticsParam.dateRange[0],
          endDateStr: this.statisticsParam.dateRange[1]
        }
      }
      this.contentTableLoading = true
      marketingStatistics(param).then(response => {
        this.statisticsInfo = response.data;
        this.statisticsInfo.contentHeatStatisticsDataList.find(item => {
          if (this.activeName === item.tabName) {
            this.dataList = item.list
            return true;
          }
        })
      }).finally(() => {
        this.contentTableLoading = false
      });
    }
  }
};
</script>

<style lang='scss'>
.crm-dashboard {
  .data-simple {
    margin: 0 10px 10px 10px;
    border: 0;
    .data-card {
      cursor: pointer;
      margin: 2px 0;
      .data-block {
        height: 100px;
        text-align: center;
        .label {
          font-weight: 500;
          padding-top: 20px;
        }
        .value {
          font-weight: 400;
          padding-top: 30px;
        }
      }
    }
    .data-card:hover {
      color: #4480f3;
      border-color: #c7d9fb;
      background-color: #ecf2fe;
    }
  }
  .data-funnel {
    border: 0;
    margin: 10px;
  }

  .moreBtn {
    float: right;
    margin-top: -25px;
  }

  .dynamicList {
    border-bottom: 1px solid #e8e6e6;
    margin-top: 12px;
    padding-bottom: 10px;
    font-size: 13px;
  }

  .dynamicList2 {
    border-bottom: 1px solid #e8e6e6;
    margin-top: 12px;
    padding-bottom: 10px;
    font-size: 14px;
  }

  .cardLeftTopTitle {
    color: #9ea1a7;
    font-size: 14px;
  }

  .dynamicCard {
    min-height: 100px;
    height: 220px;
  }

  .noDataTip {
    margin-left: 45%;
    margin-top: 15px;
    color: #b7b5b5;
    font-size: 14px;
  }

  .dynamicContent {
    margin-top: 8px;
    width: 96%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }

  .toDetailBtn {
    float: right;
    margin-top: -15px;
    padding: 0px;
  }

  .dynamicCreatTime {
    color: #969494;
  }

  .yearPicker {
    margin-top: -15px;
  }
}
</style>
